var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mail-sidebar" },
    [
      _c("MailSettings", {
        attrs: { show: _vm.settingsModal, isGridMode: _vm.isGridMode },
        on: {
          close: function ($event) {
            _vm.settingsModal = false
          },
          "layout-mode-changed": function ($event) {
            return _vm.$emit("layout-mode-changed", $event)
          },
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "sidebar-content" }, [
        _c(
          "div",
          { staticClass: "compose-wrapper" },
          [
            _c(
              "SupsisButton",
              {
                staticClass: "compose-button",
                attrs: { primary: "", block: "" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("create-new-mail")
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("add")]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("mail.newMail")))]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.showOnlyFolders
          ? _c("div", { staticClass: "mail-account-selector" }, [
              _c(
                "div",
                { staticClass: "selector-container" },
                [
                  _c(
                    "a-select",
                    {
                      staticClass: "account-select",
                      attrs: {
                        placeholder: "Mail hesabı seçin",
                        "show-search": "",
                        "option-filter-prop": "label",
                      },
                      on: {
                        change: function ($event) {
                          return _vm.selectEmail($event, "self")
                        },
                      },
                      model: {
                        value: _vm.currentEmailId,
                        callback: function ($$v) {
                          _vm.currentEmailId = $$v
                        },
                        expression: "currentEmailId",
                      },
                    },
                    _vm._l(_vm.emailAddresses, function (email) {
                      return _c(
                        "a-select-option",
                        {
                          key: email._id,
                          attrs: { value: email._id, label: email.mail },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "email-option-text",
                              attrs: { title: email.mail },
                            },
                            [_vm._v(_vm._s(email.mail))]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "SupsisButton",
                    {
                      staticClass: "settings-button",
                      attrs: { primary: "", square: "" },
                      on: {
                        click: function ($event) {
                          _vm.settingsModal = true
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("settings"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "sidebar-section folder-section" }, [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("mail.folders"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "menu-items" },
            _vm._l(_vm.folders, function (folder) {
              return _c(
                "div",
                {
                  key: folder.id,
                  staticClass: "menu-item",
                  class: {
                    active:
                      _vm.selectedFolder === folder.id &&
                      !_vm.isUserOrDeptSelected,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.selectFolder(folder.id)
                    },
                  },
                },
                [
                  _c("div", { staticClass: "item-icon" }, [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v(_vm._s(folder.icon)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "item-label" }, [
                    _vm._v(_vm._s(folder.name)),
                  ]),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _vm.userEmails.length > 0 && !_vm.showOnlyFolders
          ? _c("div", { staticClass: "sidebar-section user-section" }, [
              _c("div", { staticClass: "section-title" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("chatbotv2.users")))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "menu-items" },
                _vm._l(_vm.userEmails, function (email) {
                  return _c(
                    "div",
                    {
                      key: email._id,
                      staticClass: "menu-item horizontal",
                      class: {
                        active:
                          _vm.isUserOrDeptSelected &&
                          _vm.selectedEmailId === email._id,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectEmail(email._id, "user")
                        },
                      },
                    },
                    [
                      _vm._m(0, true),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-info" }, [
                        _c("div", { staticClass: "user-name" }, [
                          _vm._v(_vm._s(_vm.getUserMailName(email))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "user-email" }, [
                          _vm._v(_vm._s(email.mail)),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.departmentEmails.length > 0 && !_vm.showOnlyFolders
          ? _c("div", { staticClass: "sidebar-section department-section" }, [
              _c("div", { staticClass: "section-title" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("message.departments")))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "menu-items" },
                _vm._l(_vm.departmentEmails, function (email) {
                  return _c(
                    "div",
                    {
                      key: email._id,
                      staticClass: "menu-item horizontal",
                      class: {
                        active:
                          _vm.isUserOrDeptSelected &&
                          _vm.selectedEmailId === email._id,
                      },
                      on: {
                        click: function ($event) {
                          return _vm.selectEmail(email._id, "department")
                        },
                      },
                    },
                    [
                      _vm._m(1, true),
                      _vm._v(" "),
                      _c("div", { staticClass: "user-info" }, [
                        _c("div", { staticClass: "user-name" }, [
                          _vm._v(_vm._s(_vm.getDepartmentMailName(email))),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "user-email" }, [
                          _vm._v(_vm._s(email.mail)),
                        ]),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "item-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("groups")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }